import { Suspense } from 'react';
import SEOHead from '../../components/feature/SEOHead';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SectionDivider from '../../components/feature/SectionDivider';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import EngineSection from './components/EngineSection';
import MultipliersGrid from './components/MultipliersGrid';
import HowWeWorkSection from './components/HowWeWorkSection';
import LeveragePyramid from './components/LeveragePyramid';
import CaseStudies from './components/CaseStudies';
import IdealClients from './components/IdealClients';
import AuditApplicationSection from './components/AuditApplicationSection';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "name": "Force Multiplier",
        "url": siteUrl,
        "description": "Force Multiplier helps founders identify and remove the structural bottlenecks limiting growth. Bad names, weak positioning, wrong markets, broken pricing, unclear narratives."
      },
      {
        "@type": "Organization",
        "name": "Force Multiplier",
        "url": siteUrl,
        "description": "Strategic advisory for founder-led companies. Remove structural constraints and multiply output.",
        "knowsAbout": ["strategic advisory", "structural constraints", "business optimization", "founder advisory", "force multiplier"],
        "sameAs": []
      },
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/`,
        "url": `${siteUrl}/`,
        "name": "ForceM(ultiplier) | Remove Growth Bottlenecks",
        "description": "Force Multiplier helps founders identify and remove the structural bottlenecks limiting growth. Bad names, weak positioning, wrong markets, broken pricing, unclear narratives.",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Force Multiplier",
          "url": siteUrl
        }
      }
    ]
  };

  return (
    <Suspense fallback={<div className="min-h-screen bg-black" />}>
      <SEOHead
        title="ForceM(ultiplier) | Remove Growth Bottlenecks"
        description="Force Multiplier helps founders identify and remove the structural bottlenecks limiting growth. Bad names, weak positioning, wrong markets, broken pricing, unclear narratives."
        canonicalPath="/"
        schema={schema}
      />
      <div className="relative min-h-screen bg-black text-white overflow-hidden">
        <Navigation />
        <HeroSection />
        <SectionDivider variant="glow" />
        <ProblemSection />
        <SectionDivider variant="line" />
        <EngineSection />
        <SectionDivider variant="glow" />
        <MultipliersGrid />
        <SectionDivider variant="line" />
        <HowWeWorkSection />
        <SectionDivider variant="glow" />
        <LeveragePyramid />
        <SectionDivider variant="line" />
        <CaseStudies />
        <SectionDivider variant="glow" />
        <IdealClients />
        <SectionDivider variant="line" />
        <AuditApplicationSection />
        <Footer />
      </div>
    </Suspense>
  );
}
